module.exports = __webpack_public_path__ + "static/strong-6ba2a083d3b6e46e30b35b321f4d7656.png";